<!--
  CareTypeStep — the 2×2 care-type tab grid (marketplace + family). Click-to-confirm:
  tapping a tab immediately emits `select` (no separate "Continuer" CTA — proto
  decision 2026-05-25).
-->
<template>
  <div class="caretype-tabs">
    <button
      v-for="opt in CARE_TYPE_OPTIONS"
      :key="opt.key"
      type="button"
      class="caretype-tab"
      :class="{ selected: opt.key === selectedKey }"
      @click="$emit('select', opt.key)"
    >
      <span class="caretype-tab-emoji" aria-hidden="true">{{ opt.emoji }}</span>
      <span class="caretype-tab-label">{{ opt.label }}</span>
      <span v-if="opt.sub" class="caretype-tab-sub">{{ opt.sub }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { CARE_TYPE_OPTIONS } from '../../config/options'

withDefaults(defineProps<{ selectedKey?: string | null }>(), { selectedKey: null })

defineEmits<{ select: [key: string] }>()
</script>

<style scoped>
.caretype-tabs {
  width: 92%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  animation: fadeUp 0.3s both;
}
@media (max-width: 340px) {
  .caretype-tabs {
    grid-template-columns: 1fr;
  }
}
.caretype-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 10px 12px;
  background: var(--white);
  border: 1.5px solid #e2edf5; /* off-palette — DS pass to arbitrate */
  border-radius: 14px;
  cursor: pointer;
  text-align: center;
  font-family: inherit;
  transition: border-color 0.15s, background 0.15s, transform 0.1s;
  box-shadow: 0 1px 4px rgba(27, 65, 89, 0.05);
}
.caretype-tab:hover {
  border-color: var(--brand-default);
  background: #f5fafd;
}
.caretype-tab:active {
  transform: scale(0.98);
}
.caretype-tab.selected {
  border-color: var(--brand-default);
  background: var(--blue-100);
  box-shadow: 0 2px 10px rgba(45, 163, 237, 0.18);
}
.caretype-tab-emoji {
  font-size: 32px;
  line-height: 1;
  margin-bottom: 2px;
}
.caretype-tab-label {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--navy-800);
  line-height: 1.25;
}
.caretype-tab-sub {
  font-size: 11px;
  color: var(--grey-500);
  line-height: 1.35;
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .caretype-tabs {
    animation: none;
  }
}
</style>
